import { TDOOHLocationsReportChartFilters } from '../../../models/types'

export const selectDOOHLocationChartReportingFilters = ({
  reportingFilters: reportingDOOHLocationsChartFiltersState,
}: {
  reportingFilters: TDOOHLocationsReportChartFilters
}): TDOOHLocationsReportChartFilters => reportingDOOHLocationsChartFiltersState
